import { LoadingSkeleton } from 'sonata-react-components';

import './footfallReportSkeleton.scss';

type Props = {
  variant?: 'full' | 'primaryKpi' | 'chart' | 'secondaryKpi';
};

function PrimaryCardSkeleton() {
  return (
    <div className="footfallReportSkeleton__primaryCard">
      <div className="footfallReportSkeleton__primaryCardTop">
        <LoadingSkeleton height={40} width={40} />
        <LoadingSkeleton height={32} width="50%" />
      </div>
      <LoadingSkeleton height={14} width="60%" />
      <LoadingSkeleton height={12} width="75%" />
    </div>
  );
}

function SecondaryCardSkeleton() {
  return (
    <div className="footfallReportSkeleton__secondaryCard">
      <div className="footfallReportSkeleton__secondaryCardHeader">
        <LoadingSkeleton height={16} width={16} />
        <LoadingSkeleton height={14} width="60%" />
      </div>
      <LoadingSkeleton height={24} width="55%" />
    </div>
  );
}

function ChartSkeleton() {
  return (
    <div className="footfallReportSkeleton__chart">
      <div className="footfallReportSkeleton__chartHeader">
        <LoadingSkeleton height={18} width="40%" />
        <LoadingSkeleton height={24} width={130} />
      </div>
      <LoadingSkeleton height={13} width="65%" />
      <LoadingSkeleton height={13} width="45%" />
      <LoadingSkeleton height={170} width="100%" />
      <div className="footfallReportSkeleton__dayLabels">
        {Array.from({ length: 7 }).map((_, i) => (
          <LoadingSkeleton height={32} key={i} width={28} />
        ))}
      </div>
    </div>
  );
}

function PrimaryKpiSkeleton() {
  return (
    <div className="footfallReportSkeleton__primaryKpiGroup">
      <PrimaryCardSkeleton />
      <PrimaryCardSkeleton />
      <PrimaryCardSkeleton />
    </div>
  );
}

function SecondaryKpiSkeleton() {
  return (
    <div className="footfallReportSkeleton__secondaryKpiGroup">
      <div className="footfallReportSkeleton__secondaryCards">
        <SecondaryCardSkeleton />
        <SecondaryCardSkeleton />
        <SecondaryCardSkeleton />
      </div>
    </div>
  );
}

export default function FootfallReportSkeleton({ variant = 'full' }: Props) {
  if (variant === 'primaryKpi') {
    return <PrimaryKpiSkeleton />;
  }

  if (variant === 'chart') {
    return <ChartSkeleton />;
  }

  if (variant === 'secondaryKpi') {
    return <SecondaryKpiSkeleton />;
  }

  return (
    <div className="footfallReportSkeleton__grid">
      <div className="footfallReportSkeleton__storeHeaderSlot">
        <div className="footfallReportSkeleton__storeHeader">
          <div className="footfallReportSkeleton__mediaRow">
            <div className="footfallReportSkeleton__logo">
              <LoadingSkeleton height="100%" width="100%" />
            </div>
            <div className="footfallReportSkeleton__storeImage">
              <LoadingSkeleton height="100%" width="100%" />
            </div>
          </div>
          <div className="footfallReportSkeleton__mapArea">
            <LoadingSkeleton height="100%" width="100%" />
          </div>
          <div className="footfallReportSkeleton__storeInfo">
            <div className="footfallReportSkeleton__storeText">
              <LoadingSkeleton height={20} width="60%" />
              <LoadingSkeleton height={14} width="80%" />
            </div>
            <LoadingSkeleton height={36} width={110} />
          </div>
        </div>
      </div>

      <div className="footfallReportSkeleton__primaryKpiSlot">
        <PrimaryKpiSkeleton />
      </div>

      <div className="footfallReportSkeleton__chartAndSecondarySlot">
        <ChartSkeleton />
        <SecondaryKpiSkeleton />
      </div>
    </div>
  );
}
